import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Customer } from 'src/app/models/customer.model';
import { CmsService } from '../../cms.service';
import { DealsModel } from 'src/app/models/cms.model';
import { Constants } from 'src/app/shared/utils/constants';

@Component({
  selector: 'app-trading-history',
  templateUrl: './training-history.component.html',
  styles: [],
})
export class TradingHistoryComponent implements OnInit {
  data: Customer;
  dataTable: DealsModel[] = [];
  pageInfo = {
    pageSize: 10,
    pageIndex: 1,
    pageManual: 1,
    totalRecord: 0,
  };

  constructor(
    private configDialog: DynamicDialogConfig,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.data = this.configDialog.data;
    this.getListTradingHistory();
  }
  getListTradingHistory() {
    const params = {
      login: this.data.mt5Account,
      page: this.pageInfo.pageIndex,
      size: this.pageInfo.pageSize,
    };
    this.cmsService.getDeals(params).subscribe({
      next: (data) => {
        if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.dataTable = data.data;
          this.pageInfo.totalRecord = data.paging.total;
        }
      },
    });
  }
  onPageChange(event: number): void {
    this.pageInfo.pageIndex = event;
    this.pageInfo.pageManual = event;
    this.getListTradingHistory();
  }
  onKeyupPage(evt: KeyboardEvent): void {
    if (this.pageInfo.pageManual === 0) {
      this.pageInfo.pageManual = 1;
    }
    if (evt.keyCode === 13) {
      this.pageInfo.pageIndex = this.pageInfo.pageManual;
      this.getListTradingHistory();
    }
  }
}
